import React, { useContext } from 'react';
import { ThemeContext } from '../components/context/themeContext';
import MagicLinkHandler from '../components/auth/MagicLinkHandler';
import { useLocation, useNavigate } from 'react-router-dom';

function MagicLinkPage() {
  const { theme } = useContext(ThemeContext);
  const { search } = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(search).get('token');
  const returnUrl = new URLSearchParams(search).get('returnUrl') || '/dashboard';

  const handleComplete = () => {
    navigate(returnUrl);
  };

  const handleBack = () => {
    navigate('/login');
  };

  return (
    <div className={`${theme === 'dark' || theme === 'dim' ? 'dark' : ''} ${theme === 'dim' ? 'dim' : ''}`}>
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-black py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <MagicLinkHandler
            token={token}
            onComplete={handleComplete}
            onBack={handleBack}
          />
        </div>
      </div>
    </div>
  );
}


export default MagicLinkPage